import React from 'react';
import {Scrollbar, SurveyPagePropTypes} from '@ignitesales/neuro-application';
import {useBreakpoints} from "@ignitesales/neuro-application/src/neuro-ui/index.mjs";

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
    const { lg: isLargeScreen } = useBreakpoints();

    return (
        <div className={className}>
            <div className={`${componentClass}__container container`}>
                <div className={`questionGroups ${componentClass}__questionGroups`}>
                    { isLargeScreen ? <Scrollbar>{ renderQuestionGroups() }</Scrollbar> : renderQuestionGroups() }
                </div>
            </div>

        </div>
    );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
